import { ReactNode, useState } from 'react'

import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'
import { Button } from 'shared/ui/button'
import { Paper } from 'shared/ui/paper'

import { Option } from '../../select-multi'

import styles from './styles.module.scss'

export interface OptionItem extends Option {
  isSelected?: boolean
  prefix?: ReactNode
}

interface Props {
  options?: OptionItem[]
  onChange?: (name?: Option[]) => void
  buttonText?: string
}

export const BlockSelect = ({ options, onChange }: Props) => {
  const { t } = useTranslation()

  const [selected, setSelected] = useState<OptionItem[] | undefined>(options)

  const onSelect = (index: number) => {
    const copySelected = selected?.length ? [...selected] : []

    copySelected[index].isSelected = !copySelected[index].isSelected

    setSelected(copySelected)
  }

  const onClickHandler = () => {
    onChange?.(selected)
  }

  return (
    <div>
      <Paper padding={[0]}>
        <div className={styles.wrapperOptions}>
          {selected?.map((item, index) => (
            <div
              key={'option' + item.name + index}
              onClick={() => onSelect(index)}
              className={clsx(styles.option)}
            >
              <div className={styles.left}>
                {item?.prefix && item.prefix}

                <span className={styles.name}> {item?.name} </span>
              </div>

              <div className={styles.indicator}>
                {item?.isSelected ? (
                  <div className={styles.activeRadio}>
                    <AppIcon
                      id={AllIcons.TICK_BOLD}
                      className={styles.icon}
                    />
                  </div>
                ) : (
                  <div className={styles.unActiveRadio} />
                )}
              </div>
            </div>
          ))}
        </div>
      </Paper>

      <div className={styles.button}>
        <Button onClick={onClickHandler}>
          <span className={styles.text}>{t('apply')}</span>
        </Button>
      </div>
    </div>
  )
}
